import {
  IWebsiteBuilderContainerBase,
  IWebsiteBuilderContainerDataBase,
  TWebsiteBuilderContainer,
} from "./websiteBuilderContainer";
import {
  websiteBuilderGenerateDefaultHideableNodeVisibility,
} from "../websiteBuilderHideableNode";
import { IWebsiteBuilderNodeDesignStyles } from "../websiteBuilderNode";
import { websiteBuilderNormalizeValue } from "../../schema/normalization/websiteBuilderNormalizeValue";

export interface IWebsiteBuilderFormSettings {
  formId: number;
}

interface IWebsiteBuilderFormData extends IWebsiteBuilderContainerDataBase {
  type: "form";
  settings: IWebsiteBuilderFormSettings;
}

export interface IWebsiteBuilderForm extends IWebsiteBuilderContainerBase<[]> {
  container: IWebsiteBuilderFormData;
}

export function isWebsiteBuilderForm(node: TWebsiteBuilderContainer): node is IWebsiteBuilderForm {
  return node?.container?.type === "form";
}

function generateDefaultFormSettings(): IWebsiteBuilderFormSettings {
  return {
    formId: null,
  };
}

export function websiteBuilderGenerateDefaultForm(): IWebsiteBuilderForm {
  return {
    id: crypto.randomUUID(),
    type: "container",
    container: {
      type: "form",
      layout: {
        desktop: {
          position: { x: 0, y: 0 },
          dimensions: { width: 350, height: 350 },
        },
        tablet: {
          position: { x: 0, y: 0 },
          dimensions: { width: 300, height: 300 },
        },
        mobile: {
          position: { x: 0, y: 0 },
          dimensions: { width: 250, height: 250 },
        },
      },
      visibility: websiteBuilderGenerateDefaultHideableNodeVisibility(),
      zIndex: 0,
      settings: generateDefaultFormSettings(),
    },
    children: [],
  };
}

export function websiteBuilderNormalizeFormSettings(partialSettings: Partial<IWebsiteBuilderFormSettings>): IWebsiteBuilderFormSettings {
  const defaultSettings = generateDefaultFormSettings();

  if (partialSettings == null) {
    return defaultSettings;
  }

  const { formId } = partialSettings;

  const normalizedFormSettings: IWebsiteBuilderFormSettings = {
    formId: websiteBuilderNormalizeValue({
      type: "number",
      value: formId,
      defaultValue: defaultSettings.formId,
      required: false,
    }),
  };

  return normalizedFormSettings;
}

export function websiteBuilderGenerateFormDesignStyles(): IWebsiteBuilderNodeDesignStyles {
  return {
    className: "website-builder-form",
    styleProperties: {},
    styleDeclaration: "",
  };
}
